import Box from '@mui/material/Box';
import { type KeyboardEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useOpenXAgentContext } from '../../context/useOpenXAgentContext.ts';
import { OpenXAgentIcon } from '../icons/OpenXAgentIcon.tsx';
import { getButtonStyles } from './OpenXAgentTriggerFAB.styles.ts';

export const OpenXAgentTriggerFAB = () => {
  const { t } = useTranslation();
  const { setIsOpenXAgentOpen, isOpenXAgentOpen } = useOpenXAgentContext();

  const handleOnClick = useCallback(() => {
    setIsOpenXAgentOpen(true);
  }, [setIsOpenXAgentOpen]);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLDivElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        setIsOpenXAgentOpen(true);
      }
    },
    [setIsOpenXAgentOpen]
  );

  if (isOpenXAgentOpen) return null;

  return (
    <Box
      data-test="openx-agent-trigger-fab"
      role="button"
      tabIndex={0}
      aria-label={t('Launch OpenX Agent')}
      sx={getButtonStyles}
      onClick={handleOnClick}
      onKeyDown={handleKeyDown}
    >
      <OpenXAgentIcon />
    </Box>
  );
};
